// wrappers/HeaderProvider.jsx
import {
  createContext,
  useContext,
  useState,
  useCallback,
  useRef,
  useEffect,
} from "react";

const HeaderContext = createContext(null);

const DEFAULT_HEADER = {
  text: "",
  textdetails: "",
  button1: null,
  endcontent: null,
  extraContent: null,
  classNames: "",
  styles: {},
  scrollHide: true,
};

export const HeaderProvider = ({ children }) => {
 
  const scrollRef = useRef(null);
  const lastScrollY = useRef(0);

  const visible=true;
  const setVisible=()=>{};
  const [props, setProps] = useState(DEFAULT_HEADER);

  const setHeader = useCallback((config = {}) => {
    setProps(prev => ({ ...prev, ...config }));
  }, []);

  // ✅ NEW: explicit controls
  const showHeader = useCallback(() => {
    lastScrollY.current = 0; // reset scroll memory
    setVisible(true);
  }, []);

  const hideHeader = useCallback(() => {
    setVisible(false);
  }, []);

  const resetHeader = useCallback(() => {
    setProps(DEFAULT_HEADER);
    setVisible(true);
    lastScrollY.current = 0;
  }, []);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el || !props.scrollHide) return;

    const onScroll = () => {
      const y = el.scrollTop;

  

  if (y > lastScrollY.current && y > 50) {

    setVisible(false);
  } else {
    
    setVisible(true);
  }

  lastScrollY.current = y;
    };

    el.addEventListener("scroll", onScroll, { passive: true });
    return () => el.removeEventListener("scroll", onScroll);
  }, [props.scrollHide]);

  return (
    <HeaderContext.Provider
      value={{
        visible,
        props,
        setHeader,
        resetHeader,
        showHeader,   // 👈 expose
        hideHeader,   // 👈 expose
        scrollRef,
      }}
    >
      {children}
    </HeaderContext.Provider>
  );
};


export const useHeader = () => {
  const ctx = useContext(HeaderContext);
  if (!ctx) throw new Error("useHeader must be used inside HeaderProvider");
  return ctx;
};
